import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=5ae1ba5e&"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae1ba5e')) {
      api.createRecord('5ae1ba5e', component.options)
    } else {
      api.reload('5ae1ba5e', component.options)
    }
    module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=5ae1ba5e&", function () {
      api.rerender('5ae1ba5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/BaseCheckbox.vue"
export default component.exports